module.exports = __webpack_public_path__ + "static/img/logo_eng.46dce2c0.svg";